import { render } from "./index.vue?vue&type=template&id=497ea39a&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=497ea39a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-497ea39a"

export default script